app.service("definitionsView", function() {
	var $letters, $lettersNext, $lettersPrev,$lettersList,	$definitionsList;
	var definitionsKeyword,
		lettersSlideNo = 0,
		lettersSlideMax,
		mode = '';
	
	function setElements() {
		$letters = $('#definitions-letters');
		$lettersList = $('.list',$letters);
		$lettersUl = $('ul',$letters);
		$lettersNext = $('.next',$letters);
		$lettersPrev = $('.prev',$letters);
		mode=$letters.data('mode');
		resize();
		
		$definitionsList = $('#definitions-lists .list');
		definitionsKeyword = $.trim($('#definitions-keyword').val());
	}
	
	function setEvents() {
		setDefinitionEvents();
		setLetterEvents();
		var time;
		$(window).on("orientationchange resize", function() {
			clearTimeout(time);
			time=setTimeout(function(){
				resize();
			},100);
		});
	}
	
	function init() {
		setElements();
		if (definitionsKeyword !== '' && $definitionsList.length) {
			$.scrollTo($definitionsList);
		}
		setEvents();
	}
	
	function setDefinitionEvents() {
		$definitionsList.find('> .definition > a').on('click',function(event){
			event.preventDefault();
			openDefinitionContent($(this));
		});
	}
	
	function setLetterEvents() {
		if (mode === 'list') {
			$lettersUl.find('a').on('click',function(event){
				event.preventDefault();
				showDefinitionsByLetter($(this));
			});
		}
		$letters.swipe({
			swipe:function(event, direction, distance, duration, fingerCount, fingerData) {
				letterSwipe(direction);
			},
			excludedElements: "label, button, input, select, textarea, .noSwipe"
		});
		
		$lettersNext.on('click',function() {
			letterSwipe('left'); 
		});
		
		$lettersPrev.on('click',function() {
			letterSwipe('right'); 
		});
	}
	
	
	function showDefinitionsByLetter(element) {
		if(!element.hasClass('active')){
			$letters.find('a').removeClass('active');
			element.addClass('active');
			$definitionsList.hide().filter('.list-'+element.attr('data-letter')).show();
		}
	}
	
	function openDefinitionContent(element) {
		var parent=element.parent();
		parent.toggleClass('active');
		if(!parent.hasClass('loaded')){
			loadDefinitionContent({
				definition:parent.attr('data-definition')
			});
		}
	}
	
	function loadDefinitionContent(options) {
		$.ajax({
			url:'/slownik.ltr',
			data:{
				id:options.definition
			},
			success:function(html){
				appendDefinitionContent(html,options);
			}
		});
	}
	
	function appendDefinitionContent(html,options) {
		$definitionsList.find('> .definition-'+options.definition).addClass('loaded').children('.definition-content').html(html);
	}
	function resize(){
		lettersSlideNo = 0;
		lettersSlideMax=parseInt($lettersUl.width()/$lettersList.width());
		letterSwipe();
	}
	function letterSwipe(direction){
		$letters.removeClass();
		if (direction == 'left') {
			if (lettersSlideNo < lettersSlideMax) {
				lettersSlideNo++;
			}
		}
		if (direction == 'right') {
			if (lettersSlideNo > 0) {
				lettersSlideNo--;
			}
		}
		if(lettersSlideNo==lettersSlideMax-1){
			$letters.addClass('letters-slide-last');
		}
		$letters.addClass('letters-slide-'+lettersSlideNo);
	}
	
	return {
		init: init
	};
});
